import React from 'react'
import { Card } from 'antd'
import QuestionsTable from './QuestionsTable'
import QuestionDrawer from '../drawer/QuestionDrawer'
import questionSelectors from '../../../../../store/selectors/question.selectors'
import { useSelector } from 'react-redux'
import { isNumber } from 'lodash'
import assignmentSelectors from '../../../../../store/selectors/assignment.selectors'
import CompareWithLmsButton from '../compare-with-lms/CompareWithLmsButton'
import QuestionDefinitionActions from '../question-definition/QuestionDefinitionActions'
import CreateQuestionButton from './CreateQuestionButton'
import CreateComplexQuestionButton from './CreateComplexQuestionButton'

const QuestionsCard = () => {
    const editingQuestionId = useSelector(questionSelectors.editingQuestionId)
    const lmsEnabled = useSelector(assignmentSelectors.lmsEnabled)

    return (
        <Card
            title='Questions'
            extra={
                <>
                    <CreateComplexQuestionButton />
                    <CreateQuestionButton />
                    <QuestionDefinitionActions />
                    {lmsEnabled && <CompareWithLmsButton />}
                </>
            }
        >
            <QuestionsTable />
            {isNumber(editingQuestionId) && <QuestionDrawer />}
        </Card>
    )
}

export default QuestionsCard
